<template>
    <div class="test">
        <span  @click="clickFullscreen">  
           测试全屏
        </span>
        <svg-icon :icon-class="isFullscreen?'exit-fullscreen':'fullscreen'" @click="clickFullscreen" />
    </div>
</template>

<script>
import screenfull from 'screenfull'
export default {
    data() {
    return {
      isFullscreen: false
    }
  },
  watch: {
    fullscreen(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        //进行退出全屏的后的事件
        console.log('退出全屏')
      }
    }
  },
  mounted() {
    let that = this;
    window.addEventListener("keydown", this.KeyDown, true);
    window.onresize = () => {
      //调用判断全屏的方法，用来监听
      that.checkFull()
    }
  },
  beforeDestroy() {
    this.destroy()
  },

  methods: {
    KeyDown(event) {
      if (event.keyCode === 122) {
        event.returnValue = false
        this.clickFullscreen()   //触发全屏的按钮
      }
    },

    clickFullscreen() {
      screenfull.toggle();	// 全屏状态切换
      this.fullscreen = !this.fullscreen;
    },
    checkFull() {
      let fullscreen = window.fullScreen || document.webkitIsFullScreen
      this.fullscreen = fullscreen
      return fullscreen;
    },
  },
}
</script>
<style scoped>
*{
    color: #fff;
    font-size:30px ;
    text-align: center;
    line-height: 500px;
}
.screenfull-svg {
  display: inline-block;
  cursor: pointer;
  fill: #5a5e66;;
  width: 20px;
  height: 20px;
  vertical-align: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/dataChart/test.vue